function BoosterIcon() {
  return (
    <div className="booster-icon">
      <div className="booster-img" />
      <div className="booster-cable" />
    </div>
  );
}

export default BoosterIcon;
